import styled from 'styled-components';
import { DisplayBox } from '@m/alchemy-ui/DisplayBox';
import { units, typeStyle, color } from '@m/alchemy-ui/theme';

export const AnchorContainer = styled.a<{ href: string | undefined }>`
  background: none;
  border: none;
  padding: 0;
  width: 100%;
`;

export const ItemContainer = styled(DisplayBox)`
  align-items: center;
  border: none;
  color: ${color('contrast', { palette: 'illustrativeSteelGrey' })};
  display: flex;
  flex-direction: column;
  height: 180px;
  justify-content: center;
`;

export const IconLabelContainer = styled.div`
  display: block;
  text-align: center;
`;

export const Icon = styled.div<{ backgroundColor: string }>`
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border-radius: 14px;
  color: #ffffff;
  display: inline-flex;
  height: ${units(5)};
  justify-content: center;
  margin: 0 auto;
  transform: rotateZ(45deg);
  width: ${units(5)};

  & > svg {
    height: 20px;
    transform: rotateZ(-45deg);
    width: 20px;
  }
`;

export const Title = styled.h1`
  ${typeStyle('subHeaderM')};
  text-align: center;
  margin-top: ${units(1)};
`;

export const Subtitle = styled.p`
  ${typeStyle('captionM')};
  color: ${color('typeSubHeader', { palette: 'structural' })};
  text-align: center;
  margin-top: ${units(0.5)};
`;
